(function () {
  'use strict';

  var copy = {
  "en": {
    "timer": "Offer ends in",
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "hTitle": "15% Off Sitewide",
    "hCopy": "Automatically applied at checkout. No code needed. Ends October 20.",
    "cartTitle": "15% Off Sitewide",
    "cartCopy": "Automatically applied at checkout. No code needed. Ends October 20.",
    "cartNote": "Cannot be combined with other discounts. Gift cards excluded."
  },
  "de": {
    "timer": "Aktion endet in",
    "days": "Tage",
    "hours": "Std.",
    "minutes": "Min.",
    "seconds": "Sek.",
    "hTitle": "15 % Rabatt auf alles",
    "hCopy": "Wird im Checkout automatisch abgezogen. Kein Code nötig. Bis 20. Oktober.",
    "cartTitle": "15 % Rabatt auf alles",
    "cartCopy": "Wird im Checkout automatisch abgezogen. Kein Code nötig. Bis 20. Oktober.",
    "cartNote": "Nicht mit anderen Rabatten kombinierbar. Geschenkgutscheine ausgeschlossen."
  },
  "fr": {
    "timer": "Fin de l’offre dans",
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Min.",
    "seconds": "Sec.",
    "hTitle": "-15 % sur tout le site",
    "hCopy": "Remise appliquée automatiquement au paiement. Aucun code requis. Jusqu’au 20 octobre.",
    "cartTitle": "-15 % sur tout le site",
    "cartCopy": "Remise appliquée automatiquement au paiement. Aucun code requis. Jusqu’au 20 octobre.",
    "cartNote": "Non cumulable avec d’autres remises. Cartes-cadeaux exclues."
  }
};

  var config = document.getElementById('yeese-campaign-config');
  var locale = ((config && config.dataset.locale) || document.documentElement.lang || 'en').slice(0,2).toLowerCase();
  var t = copy[locale] || copy.en;

  // Announcement copy is managed by theme settings and Shopify translations.
  function parseDeadline(value) {
    if (!value) return NaN;

    var direct = Date.parse(value);
    if (Number.isFinite(direct)) return direct;

    // Shopify translations can localize a text setting that contains an ISO
    // date. Accept common German/French day-first forms and rebuild ISO 8601.
    var match = value.trim().match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})(?:\s*(?:,|à)?\s*(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(Z|[+-]\d{2}:?\d{2})?)?$/i);
    if (!match) return NaN;

    var day = match[1].padStart(2, '0');
    var month = match[2].padStart(2, '0');
    var year = match[3];
    var hours = (match[4] || '23').padStart(2, '0');
    var minutes = match[5] || '59';
    var seconds = match[6] || '59';
    var zone = match[7] || '';
    if (/^[+-]\d{4}$/.test(zone)) zone = zone.slice(0, 3) + ':' + zone.slice(3);

    return Date.parse(year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + zone);
  }

  function setupCountdown(root) {
    var deadline = parseDeadline(root.dataset.deadline);
    if (!Number.isFinite(deadline)) return;
    root.querySelector('[data-countdown-title]').textContent = t.timer;
    [['days',t.days],['hours',t.hours],['minutes',t.minutes],['seconds',t.seconds]].forEach(function (item) {
      root.querySelector('[data-label-' + item[0] + ']').textContent = item[1];
    });
    function update() {
      var left = Math.max(0, deadline - Date.now());
      var seconds = Math.floor(left / 1000);
      var values = {days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60};
      Object.keys(values).forEach(function (key) { root.querySelector('[data-' + key + ']').textContent = String(values[key]).padStart(2,'0'); });
      if (!left) root.querySelector('[data-countdown-title]').textContent = root.dataset.expiredText || '';
    }
    update(); window.setInterval(update, 1000);
  }

  function bindCopy(scope) {
    scope.querySelectorAll('[data-copy-code]:not([data-copy-bound])').forEach(function (button) {
      button.dataset.copyBound = 'true'; button.textContent = t.button;
      button.addEventListener('click', function () {
        var code = button.dataset.copyCode;
        var done = function () { button.textContent = t.copied; window.setTimeout(function(){button.textContent=t.button;},1600); };
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done);
        else { var input=document.createElement('textarea'); input.value=code; document.body.appendChild(input); input.select(); document.execCommand('copy'); input.remove(); done(); }
      });
    });
  }

  function mountProduct() {
    if (Date.now() >= Date.parse('2026-10-20T23:59:00+02:00')) return;
    if (document.querySelector('.yeese-promo--product')) return;
    var anchor = document.querySelector('.product-info__price');
    var template = document.getElementById('yeese-product-promo-template');
    if (!anchor || !template) return;
    var node = template.content.firstElementChild.cloneNode(true);
    if (config && config.dataset.giftCardProduct === 'true') return;
    node.querySelector('[data-promo-title]').textContent = t.hTitle;
    node.querySelector('[data-promo-copy]').textContent = t.hCopy;

    anchor.insertAdjacentElement('afterend', node); bindCopy(node);
  }

  function mountCart() {
    if (Date.now() >= Date.parse('2026-10-20T23:59:00+02:00')) return;
    var drawer = document.querySelector('cart-drawer, .js-cart-drawer');
    if (!drawer || drawer.querySelector('.yeese-promo--cart')) return;
    var anchor = drawer.querySelector('.cart-drawer__footer');
    var template = document.getElementById('yeese-cart-promo-template');
    if (!anchor || !template) return;
    var node = template.content.firstElementChild.cloneNode(true);
    node.querySelector('[data-cart-title]').textContent=t.cartTitle;
    node.querySelector('[data-cart-copy]').textContent=t.cartCopy;
    node.querySelector('[data-cart-note]').textContent=t.cartNote;
    anchor.insertAdjacentElement('beforebegin',node); bindCopy(node);
  }

  function init() {
    
    document.querySelectorAll('[data-yeese-countdown]').forEach(setupCountdown);
    mountProduct(); mountCart();
    new MutationObserver(function(){mountProduct();mountCart();}).observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
